var stepsUsers = [{
  element: '#add-new',
  popover: {
    title: 'Add New User',
    position: 'right'
  }
}];
export default stepsUsers;